export default __webpack_public_path__ + "static/media/8.859a16f4.jpg";